import { recentOrdersStyles } from "@insite/content-library/Widgets/Common/RecentOrders";
import getColor from "@insite/mobius/utilities/getColor";

import { css } from "styled-components";

Object.assign(recentOrdersStyles, {
    cardList: {
        gridContainer: {
            css: css`
                border: 1px solid ${getColor("common.border")};
                margin-bottom: 20px;
            `,
        },
    },
    noOrdersFoundGridItem: {
        width: 12,
        css: css`
            justify-content: center;
        `,
    },
});
